<template>
  <span v-if="canInvite" class="invite-assistant">
    <button type="button" class="btn btn--outline btn--sm" @click="openModal">
      Convidar assistente
    </button>

    <b-modal
      v-model="showModal"
      title="Convidar assistente"
      hide-footer
      centered
    >
      <form @submit.prevent="submit">
        <div class="mb-3">
          <label class="form-label" for="ia-name">Nome completo</label>
          <input
            id="ia-name"
            v-model.trim="form.name"
            type="text"
            class="form-control"
            placeholder="Ex.: Maria Souza"
          />
        </div>

        <div class="mb-3">
          <label class="form-label" for="ia-email">E-mail</label>
          <input
            id="ia-email"
            v-model.trim="form.email"
            type="email"
            class="form-control"
            placeholder="assistente@exemplo.com"
          />
        </div>

        <p class="invite-assistant__hint">
          A pessoa receberá um e-mail para criar a senha e acessar a clínica
          como Atendimento.
        </p>

        <div class="invite-assistant__actions">
          <button
            type="button"
            class="btn btn--ghost btn--sm"
            @click="showModal = false"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn btn--accent btn--sm"
            :disabled="sending"
          >
            {{ sending ? "Enviando..." : "Enviar convite" }}
          </button>
        </div>
      </form>
    </b-modal>
  </span>
</template>

<script>
import { ClinicSession, ClinicConfig } from "@/services/clinica";

// Botão "Convidar assistente" no painel do médico. Só aparece quando o médico
// logado é admin de uma clínica (membership via /clinica/session). Reusa o mesmo
// endpoint do Config › Operadores (POST /clinica/staff) com perfil "atendimento".
export default {
  name: "InviteAssistant",
  data() {
    return {
      canInvite: false,
      adminClinicId: null,
      showModal: false,
      sending: false,
      form: { name: "", email: "" }
    };
  },
  async created() {
    try {
      const { data } = await ClinicSession.session();
      // O convite vai para a clínica onde o médico é admin (US-C11).
      const adminClinic = (data.clinics || []).find(c => c.role === "admin");
      this.adminClinicId = adminClinic ? adminClinic.id : null;
      this.canInvite = !!(
        data.operator &&
        data.operator.clinicStaff &&
        this.adminClinicId
      );
    } catch (error) {
      this.canInvite = false;
    }
  },
  methods: {
    openModal() {
      this.form = { name: "", email: "" };
      this.showModal = true;
    },
    isValid() {
      const hasFullName = /\S+\s+\S+/.test(this.form.name || "");
      const hasEmail = /^\S+@\S+\.\S+$/.test(this.form.email || "");
      return hasFullName && hasEmail;
    },
    async submit() {
      if (!this.isValid()) {
        this.$toast.error("Informe o nome completo e um e-mail válido.");
        return;
      }
      this.sending = true;
      try {
        await ClinicConfig.inviteOperator(
          {
            name: this.form.name,
            email: this.form.email,
            role: "atendimento"
          },
          { clinicId: this.adminClinicId }
        );
        this.$toast.success("Convite enviado por e-mail.");
        this.showModal = false;
        this.form = { name: "", email: "" };
      } catch (error) {
        this.$toast.error("Não foi possível enviar o convite.");
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style scoped>
.invite-assistant__hint {
  font-size: 0.85rem;
  color: var(--color-text-muted, #6b7280);
  margin-bottom: 1rem;
}
.invite-assistant__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
